const STEP_HIDDEN_CLASS = "hora-form-step-hidden";
const STEP_SELECTOR = ".hora-form-step";
const MULTISTEP_SELECTOR = ".hora-form-fields[data-multistep]";
export class MultiStepForm {
    constructor(container) {
        this._activeIndex = 0;
        this._container = container;
        this._steps = Array.from(container.querySelectorAll(STEP_SELECTOR));
        this._followingSiblings = this._collectFollowingSiblings();
        this._buildNav();
        this._showStep(0);
    }
    static init(formEl) {
        const container = formEl.querySelector(MULTISTEP_SELECTOR);
        if (!container) {
            return null;
        }
        return new MultiStepForm(container);
    }
    /** Activates the step containing `el` if it isn't already the active one. */
    revealInvalid(el) {
        const step = el.closest(STEP_SELECTOR);
        const index = step ? this._steps.indexOf(step) : -1;
        if (index !== -1 && index !== this._activeIndex) {
            this._showStep(index);
            return;
        }
        // Outside every step = the terms/newsletter/actions block after the fields
        // container, visible only on the final step (an Enter-key submit can reach here
        // from any step) — reveal it or reportValidity() can't focus the field.
        if (index === -1 && !this._container.contains(el)) {
            this._showStep(this._steps.length - 1);
        }
    }
    _collectFollowingSiblings() {
        const siblings = [];
        let next = this._container.nextElementSibling;
        while (next) {
            if (next instanceof HTMLElement) {
                siblings.push(next);
            }
            next = next.nextElementSibling;
        }
        return siblings;
    }
    _buildNav() {
        const nav = document.createElement("div");
        nav.className = "hora-form-step-nav";
        this._prevBtn = document.createElement("button");
        this._prevBtn.type = "button";
        this._prevBtn.className = "btn btn-secondary hora-form-step-btn hora-form-step-prev";
        this._prevBtn.textContent = this._i18n("step_prev", "Previous");
        this._prevBtn.addEventListener("click", () => this._goPrev());
        this._indicator = document.createElement("span");
        this._indicator.className = "hora-form-step-indicator";
        this._nextBtn = document.createElement("button");
        this._nextBtn.type = "button";
        this._nextBtn.className = "btn btn-primary hora-form-step-btn hora-form-step-next";
        this._nextBtn.textContent = this._i18n("step_next", "Next");
        this._nextBtn.addEventListener("click", () => this._goNext());
        nav.appendChild(this._prevBtn);
        nav.appendChild(this._indicator);
        nav.appendChild(this._nextBtn);
        this._container.insertAdjacentElement("afterend", nav);
    }
    _goPrev() {
        if (this._activeIndex > 0) {
            this._showStep(this._activeIndex - 1);
        }
    }
    _goNext() {
        const activeStep = this._steps[this._activeIndex];
        const fields = activeStep.querySelectorAll("input, select, textarea");
        for (const field of Array.from(fields)) {
            if (!field.checkValidity()) {
                field.reportValidity();
                return;
            }
        }
        if (this._activeIndex < this._steps.length - 1) {
            this._showStep(this._activeIndex + 1);
        }
    }
    _showStep(index) {
        this._activeIndex = index;
        this._steps.forEach((step, i) => {
            step.classList.toggle(STEP_HIDDEN_CLASS, i !== index);
        });
        const isFinalStep = index === this._steps.length - 1;
        this._followingSiblings.forEach((el) => {
            el.classList.toggle(STEP_HIDDEN_CLASS, !isFinalStep);
        });
        this._prevBtn.classList.toggle(STEP_HIDDEN_CLASS, index === 0);
        this._prevBtn.disabled = index === 0;
        this._nextBtn.classList.toggle(STEP_HIDDEN_CLASS, isFinalStep);
        this._updateIndicator();
    }
    _updateIndicator() {
        const template = this._i18n("step_indicator", "Step %1$s of %2$s");
        this._indicator.textContent = template
            .replace("%1$s", String(this._activeIndex + 1))
            .replace("%2$s", String(this._steps.length));
    }
    _i18n(key, fallback) {
        var _a;
        return ((_a = window.hora_events.i18n) === null || _a === void 0 ? void 0 : _a[key]) || fallback;
    }
}
